import React, { useEffect, useState, useTransition } from "react";
import {
  Box,
  Container,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
} from "@mui/material";
// import { Box, Container } from "@mui/material";
import { Formik, Form } from "formik";
import { updateProfile } from "../../../../core/redux/action/userProfile";
import LoadingButton from "@mui/lab/LoadingButton";

import PersonalInformation1 from "./Forms/PersonalInformation1";
import PersonalInformation2 from "./Forms/PersonalInformation2";
import EducationBackground from "./Forms/EducationalBackground";
import WorkingExperience from "./Forms/WorkingExperience";

import RegisterSuccessPhD from "./RegisterSuccess";

import validationSchema from "./FormModel/validationSchema";
import phdFormModel from "./FormModel/phdFormModel";
import formInitialValues from "./FormModel/formInitialValues";

import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../../../core/service/users.service";

import useStyles from "./styles";

const steps = [
  "Personal Information",
  "PhD Student Information",
  "Education Background",
  "Working Experience",
];
const { formId, formField } = phdFormModel;
const phd_3y = "normalCourse3yrs";
const value = "testName";
function _renderStepContent(step,data) {
  switch (step) {
    case 0:
      return <PersonalInformation1 formField={formField} />;
    case 1:
      return <PersonalInformation2 formField={formField} />;
    case 2:
      return <EducationBackground formField={formField} />;
    case 3:
      return <WorkingExperience formField={formField} userData={data} />;
    default:
      return <>Not Found</>;
  }
}

export default function EditPhDPage() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [user, setUser] = useState({});
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    getUserProfile(id);
    
  }, []);

  useEffect(() => {
   
  }, [user]);

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    for (const [key, value] of Object.entries(values)) {
      if (value?.file) {
        formData.append(key, value.file);
      } else {
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value ? value : "");
        }
      }
    }
    //phd
    formData.append("role", values.c2fScholarshipProgram === phd_3y ? 2 : 3);
    formData.append("user_id", id);
    dispatch(updateProfile(formData));

    await _sleep(1000);
    actions.setSubmitting(false);
    setActiveStep(activeStep + 1);
  }

  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  const getUserProfile = async (id) => {
    await getProfile(id).then((res) => {
      //console.log('res ===> ',res);
      mapValues(res);
    });
  };

  const mapValues = (data) => {
    //console.log('data ====>', data)
    const formValues = formInitialValues;
    //console.log('form ====>', formValues)
    formValues.photo = data?.photo;
    formValues.email = data?.email;
    // formValues.password = data?.password;
    formValues.titleNameEng = data?.personal_infomation?.title_name_en;
    formValues.firstNameEng = data?.personal_infomation?.name_en;
    formValues.middleNameEng = data?.personal_infomation?.middle_name_en
      ? data?.personal_infomation?.middle_name_en
      : "-";
    formValues.lastNameEng = data?.personal_infomation?.surname_en;
    formValues.titleNameThai = data?.personal_infomation?.title_name_th;
    formValues.firstNameThai = data?.personal_infomation?.name_th;
    formValues.middleNameThai = data?.personal_infomation?.middle_name_th
      ? data?.personal_infomation?.middle_name_th
      : "-";
    formValues.lastNameThai = data?.personal_infomation?.surname_th
      ? data?.personal_infomation?.surname_th
      : "-";
    formValues.gender = data?.personal_infomation?.gender;
    formValues.dateOfBirth = data?.personal_infomation?.birth_date;
    formValues.maritalStatus = data?.personal_infomation?.marital_status;
    formValues.bloodType = data?.personal_infomation?.blood_type;
    formValues.idCard = data?.personal_infomation?.card_id_or_passport;
    formValues.nationality = data?.personal_infomation?.nationality;
    formValues.studentId = data?.personal_infomation?.student_id;

    formValues.yearOfTheContract = data?.personal_infomation?.year_contract;
    formValues.faculty = data?.student_phd_information?.faculty;
    formValues.major = data?.student_phd_information?.major;
    formValues.c2fScholarshipProgram =
      data?.student_phd_information?.scholarship_program;
    formValues.mobileThai = data?.student_phd_information?.mobile_number_th;
    formValues.mobileCountry =
      data?.student_phd_information?.mobile_number_country;

    formValues.mentor_id = data?.my_mentor?.mentor_id;
    formValues.mentorName =
      (data?.my_mentor?.title_name_en
        ? data?.my_mentor?.title_name_en + " "
        : "") +
      (data?.my_mentor?.middle_name_en
        ? data?.my_mentor?.middle_name_en + " "
        : "") +
      data?.my_mentor?.name_en;
    formValues.mentorEmail = data?.my_mentor?.mentor_id;

    formValues.startFellowship = data?.student_phd_information?.start_reciving;
    formValues.contractEnd = data?.student_phd_information?.contract_end;
    formValues.researchArea = data?.student_phd_information?.research_area;
    formValues.addressInTheCountryOfResidence =
      data?.student_phd_information?.address_country_residence;
    formValues.addressInThailand = data?.student_phd_information?.address_th;

    formValues.nameOfTheBachelorDegree =
      data?.phd_educational_background?.name_bachelor_degree;
    formValues.graduatedFromUniversityInstitute =
      data?.phd_educational_background?.graduated_university_bachelor_degree;
    
    formValues.dateOfBachelorDegreeGraduation =
      data?.phd_educational_background?.date_bachelor_degree;
    formValues.nameOfMasterDegree =
      data?.phd_educational_background?.name_master_degree;
    formValues.graduatedMasterFromUniversityInstitute =
      data?.phd_educational_background?.graduated_university_master_degree;

    formValues.countryOfTheBachelorUniversityInstitute =
      data?.phd_educational_background?.country_bachelor_degree;
    formValues.countryOfTheMasterUniversityInstitute =
      data?.phd_educational_background?.country_master_degree;


    const work_exp_arr = [];

    data?.working_experience?.forEach((element) => {
      work_exp_arr.push({
        position: element.position,
        companyOrganization: element.compony,
        country: element.country,
        started: element.started,
        ended: element.ended,
        stillInRole: element.still_role,
        id: element.id,
      });
    });

    formValues.workingExperienceList = work_exp_arr;

    formValues.cvOrResume = data?.personal_infomation?.cv_resume;

    //console.log("formValues => ", formValues);
    
    setUserData(formValues);
  };

  return (
    <Container>
      <Box sx={{ textAlign: "center" }}>
        <>
          <Typography component="h1" variant="h4" align="center">
            Update for C2F PhD Student
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <RegisterSuccessPhD />
          ) : (
            <Formik
              // initialValues={formInitialValues}
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
             
            >
              {({ isSubmitting }) => {
                return (
                  <Form id={formId}>
                    {_renderStepContent(activeStep,formInitialValues)}

                    <Box className={classes.buttons}>
                      {activeStep !== 0 && (
                        <Button
                          onClick={_handleBack}
                          className={classes.button}
                        >
                          Back
                        </Button>
                      )}
                      <Box className={classes.wrapper}>
                        <LoadingButton
                          loading={isSubmitting}
                          disabled={isSubmitting}
                          type="submit"
                          variant="contained"
                          color="primary"
                          className={classes.button}
                        >
                          {isLastStep ? "Submit" : "Next"}
                        </LoadingButton>
                      </Box>
                    </Box>
                  </Form>
                );
              }}
            </Formik>
          )}
        </>
      </Box>
    </Container>
  );
}
